import React, { useEffect, useState } from 'react';
import { Box, Button, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import ContentCopyIcon from '@material-ui/icons/FileCopyOutlined';
import { decryptText, encryptText } from '../BuzzSlice';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import { copyTextToClipboard } from '../../../utils/helpers';

const EncryptAndDecrypt = () => {
  const dispatch = useDispatch();

  const [application, setApplication] = useState('');
  const [plainText, setPlainText] = useState('');
  const [encryptedText, setEncryptedText] = useState('');

  const [isPlainTextInputChanged, setIsPlainTextInputChanged] = useState(false);
  const [isEncryptedTextInputChanged, setIsEncryptedTextInputChanged] =
    useState(false);

  const handlePlainTextChange = (e) => {
    const value = e.target.value;
    setPlainText(() => value);

    if (value) setIsPlainTextInputChanged(true);
    else setEncryptedText(() => '');
  };
  const handleEncryptedTextChange = (e) => {
    const value = e.target.value;
    setEncryptedText(() => value);

    if (value) setIsEncryptedTextInputChanged(true);
    else setPlainText(() => '');
  };

  useEffect(() => {
    if (!isPlainTextInputChanged) {
      setIsPlainTextInputChanged(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      dispatch(encryptText({ application, plainText }))
        .unwrap()
        .then((res) => {
          setEncryptedText(() => res.encryptedText);
        })
        .finally(() => {
          setIsPlainTextInputChanged(false);
        });
    }, 700);

    return () => {
      clearTimeout(timeoutId);
      setIsPlainTextInputChanged(false);
    };
  }, [isPlainTextInputChanged]);

  useEffect(() => {
    if (!isEncryptedTextInputChanged) {
      setIsEncryptedTextInputChanged(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      dispatch(decryptText({ application, encryptedText }))
        .unwrap()
        .then((res) => {
          setPlainText(() => res.plainText);
        })
        .finally(() => {
          setIsEncryptedTextInputChanged(false);
        });
    }, 700);

    return () => {
      clearTimeout(timeoutId);
      setIsEncryptedTextInputChanged(false);
    };
  }, [isEncryptedTextInputChanged]);

  const [isPlainTextCopied, setIsPlainTextCopied] = useState(false);
  const [isEncryptedTextCopied, setIsEncryptedTextCopied] = useState(false);

  const handleCopyPlainText = async () => {
    await copyTextToClipboard(plainText);
    setIsPlainTextCopied(true);
  };
  const handleCopyEncryptedText = async () => {
    await copyTextToClipboard(encryptedText);
    setIsEncryptedTextCopied(true);
  };

  useEffect(() => {
    if (!isPlainTextCopied) return;

    const timeoutId = setTimeout(() => {
      setIsPlainTextCopied(false);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isPlainTextCopied]);

  useEffect(() => {
    if (!isEncryptedTextCopied) return;

    const timeoutId = setTimeout(() => {
      setIsEncryptedTextCopied(false);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isEncryptedTextCopied]);

  return (
    <Box>
      <p style={{ fontSize: '1.5rem', fontWeight: 500 }}>Encrypt & Decrypt</p>

      <Box
        display={'flex'}
        flexDirection={'column'}
        // alignItems={'center'}
        style={{ gap: '1rem' }}
        maxWidth={'600px'}>
        <BuzzSelect
          size="small"
          valueKey="value"
          labelKey="label"
          label="Application"
          options={[
            {
              label: 'Datadog',
              value: 'DATADOG',
            },
          ]}
          value={application}
          onChange={(e) => {
            setApplication(e.target.value);
          }}
        />
        <Box display={'flex'} alignItems={'flex-end'} style={{ gap: '1rem' }}>
          <Box display={'flex'} flexGrow={1}>
            <BuzzInput
              size="small"
              type="text"
              label={'Plain Text'}
              value={plainText}
              placeholder={'e.g. Albert Roy'}
              onChange={handlePlainTextChange}
              disabled={!application}
            />
          </Box>
          <Tooltip title={isPlainTextCopied ? 'Text Copied' : 'Copy the Text'}>
            <Button
              color="primary"
              onClick={handleCopyPlainText}
              style={{
                backgroundColor: isPlainTextCopied ? '#22c55e' : '',
                color: isPlainTextCopied ? 'white' : '',
              }}
              disabled={!plainText}>
              <ContentCopyIcon />
            </Button>
          </Tooltip>
        </Box>
        <img
          src={'/assets/icons/loop.png'}
          alt="convert icon"
          width={'30'}
          style={{ margin: 'auto' }}
        />
        <Box display={'flex'} alignItems={'flex-end'} style={{ gap: '1rem' }}>
          <Box display={'flex'} flexGrow={1}>
            <BuzzInput
              size="small"
              type="text"
              label={'Encrypted Text'}
              value={encryptedText}
              placeholder={'e.g. 83dd95b7a60c8b875782a321'}
              onChange={handleEncryptedTextChange}
              disabled={!application}
            />
          </Box>
          <Tooltip
            title={isEncryptedTextCopied ? 'Text Copied' : 'Copy the Text'}>
            <Button
              color="primary"
              onClick={handleCopyEncryptedText}
              style={{
                backgroundColor: isEncryptedTextCopied ? '#22c55e' : '',
                color: isEncryptedTextCopied ? 'white' : '',
              }}
              disabled={!encryptedText}>
              <ContentCopyIcon />
            </Button>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default EncryptAndDecrypt;
